export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7956.e904eaf5.jpg";